const ec2subnets = `<?xml version="1.0" encoding="UTF-8"?>
<DescribeSubnetsResponse xmlns="http://ec2.amazonaws.com/doc/2016-11-15/">
    <requestId>b0d378fd-6b77-4130-ba1d-e8b520e88192</requestId>
    <subnetSet>
        <item>
            <subnetId>subnet-0d7a2ddb541e8c0d2</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-0d7a2ddb541e8c0d2</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.3.160/27</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>10</availableIpAddressCount>
            <availabilityZone>us-east-1c</availabilityZone>
            <availabilityZoneId>use1-az2</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-groupname</key>
                    <value>WIPRO</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>WIPRO-AZ-1c</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>N</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-97583de1</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-97583de1</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.14.192/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>43</availableIpAddressCount>
            <availabilityZone>us-east-1d</availabilityZone>
            <availabilityZoneId>use1-az4</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1d-04</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-00f94558</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-00f94558</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.10.0/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>46</availableIpAddressCount>
            <availabilityZone>us-east-1a</availabilityZone>
            <availabilityZoneId>use1-az6</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>KubernetesCluster</key>
                    <value>net9xny513</value>
                </item>
                <item>
                    <key>fsx_cvo_subnet</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1a-01</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-b334bac4</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-b334bac4</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.2.0/24</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>4</availableIpAddressCount>
            <availabilityZone>us-east-1d</availabilityZone>
            <availabilityZoneId>use1-az4</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>aiq-public-api</key>
                    <value>yes</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>hcl-east-1d1</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>kubernetes.io/cluster/kgeetha-atom</key>
                    <value>shared</value>
                </item>
                <item>
                    <key>KubernetesCluster</key>
                    <value>netnlqga8h</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-da583dac</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-da583dac</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.14.0/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>57</availableIpAddressCount>
            <availabilityZone>us-east-1d</availabilityZone>
            <availabilityZoneId>use1-az4</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>fsx_cvo_subnet</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1d-01</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-cc8b2095</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-cc8b2095</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.0.0/24</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>45</availableIpAddressCount>
            <availabilityZone>us-east-1a</availabilityZone>
            <availabilityZoneId>use1-az6</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>kubernetes.io/cluster/kgeetha-atom</key>
                    <value>shared</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>hcl-east-1a1</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>KubernetesCluster</key>
                    <value>netndwzvwr</value>
                </item>
                <item>
                    <key>kubernetes.io/cluster/pbhat-test-ci-operators</key>
                    <value>shared</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-4a22373d</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-4a22373d</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.8.0/24</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>228</availableIpAddressCount>
            <availabilityZone>us-east-1d</availabilityZone>
            <availabilityZoneId>use1-az4</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>kubernetes.io/cluster/kvalliyu-test2</key>
                    <value>shared</value>
                </item>
                <item>
                    <key>kubernetes.io/cluster/pbhat-test-ci-operators</key>
                    <value>shared</value>
                </item>
                <item>
                    <key>KubernetesCluster</key>
                    <value>netirk5j70</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>hcl-east-1d3</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>kubernetes.io/role/internal-elb</key>
                    <value>1</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-a4583dd2</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-a4583dd2</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.14.128/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1d</availabilityZone>
            <availabilityZoneId>use1-az4</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1d-03</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-9868c2b2</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-9868c2b2</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.13.192/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>53</availableIpAddressCount>
            <availabilityZone>us-east-1c</availabilityZone>
            <availabilityZoneId>use1-az2</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1c-08</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-3e63c914</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-3e63c914</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.12.128/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1c</availabilityZone>
            <availabilityZoneId>use1-az2</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1c-03</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-5f942e07</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-5f942e07</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.11.64/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1a</availabilityZone>
            <availabilityZoneId>use1-az6</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>eco-creator</key>
                    <value>dinsmore</value>
                </item>
                <item>
                    <key>creator</key>
                    <value>dinsmore</value>
                </item>
                <item>
                    <key>eco-email</key>
                    <value>dinsmore@netapp.com</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1a-06</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-b93aa494</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-b93aa494</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.9.0/24</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>251</availableIpAddressCount>
            <availabilityZone>us-east-1c</availabilityZone>
            <availabilityZoneId>use1-az2</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1c-09</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-c55530b3</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-c55530b3</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.15.192/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1d</availabilityZone>
            <availabilityZoneId>use1-az4</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-creator</key>
                    <value>dinsmore</value>
                </item>
                <item>
                    <key>eco-email</key>
                    <value>dinsmore@netapp.com</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1d-08</value>
                </item>
                <item>
                    <key>creator</key>
                    <value>dinsmore</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-413aef6a</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-413aef6a</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.4.0/24</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>234</availableIpAddressCount>
            <availabilityZone>us-east-1c</availabilityZone>
            <availabilityZoneId>use1-az2</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>aiq-public-api</key>
                    <value>yes</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>hcl-east-1c2</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-fa9f0f9f</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-fa9f0f9f</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-62720a04</vpcId>
            <cidrBlock>10.0.2.0/24</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>250</availableIpAddressCount>
            <availabilityZone>us-east-1b</availabilityZone>
            <availabilityZoneId>use1-az1</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-shared-resource</key>
                    <value>N</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>SGWS_Private_1</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-b7583dc1</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-b7583dc1</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.14.64/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1d</availabilityZone>
            <availabilityZoneId>use1-az4</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1d-02</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>fsx_customer_subnet</key>
                    <value>Y</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-082afa35fa794d490</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-082afa35fa794d490</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.3.192/27</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>27</availableIpAddressCount>
            <availabilityZone>us-east-1d</availabilityZone>
            <availabilityZoneId>use1-az4</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-shared-resource</key>
                    <value>N</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>WIPRO-AZ-1d</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>WIPRO</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-d4200f8d</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-d4200f8d</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.6.0/24</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>249</availableIpAddressCount>
            <availabilityZone>us-east-1a</availabilityZone>
            <availabilityZoneId>use1-az6</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>Name</key>
                    <value>DO_NOT_USE_hcl-east-1a3</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>N</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-7e68c254</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-7e68c254</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.13.0/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1c</availabilityZone>
            <availabilityZoneId>use1-az2</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1c-05</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-6262c848</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-6262c848</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.12.0/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>55</availableIpAddressCount>
            <availabilityZone>us-east-1c</availabilityZone>
            <availabilityZoneId>use1-az2</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>fsx_cvo_subnet</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1c-01</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-26f9457e</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-26f9457e</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.10.64/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1a</availabilityZone>
            <availabilityZoneId>use1-az6</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1a-02</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-d362c8f9</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-d362c8f9</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.12.64/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1c</availabilityZone>
            <availabilityZoneId>use1-az2</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1c-02</value>
                </item>
                <item>
                    <key>fsx_customer_subnet</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-61942e39</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-61942e39</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.11.192/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1a</availabilityZone>
            <availabilityZoneId>use1-az6</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1a-08</value>
                </item>
                <item>
                    <key>creator</key>
                    <value>dinsmore</value>
                </item>
                <item>
                    <key>eco-creator</key>
                    <value>dinsmore</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>eco-email</key>
                    <value>dinsmore@netapp.com</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-f45772af</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-f45772af</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-62720a04</vpcId>
            <cidrBlock>10.0.1.0/24</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>251</availableIpAddressCount>
            <availabilityZone>us-east-1a</availabilityZone>
            <availabilityZoneId>use1-az6</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>Name</key>
                    <value>SGWS_Public_1</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>N</value>
                </item>
                <item>
                    <key>KubernetesCluster</key>
                    <value>neta3mcgpg</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-0a476f102a6bc55fc</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-0a476f102a6bc55fc</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.3.0/25</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>123</availableIpAddressCount>
            <availabilityZone>us-east-1a</availabilityZone>
            <availabilityZoneId>use1-az6</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>Name</key>
                    <value>WIPRO-AZ-1a</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>WIPRO</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>N</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-0e530e25</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-0e530e25</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.7.0/24</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>242</availableIpAddressCount>
            <availabilityZone>us-east-1c</availabilityZone>
            <availabilityZoneId>use1-az2</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>hcl-east-1c3</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-493aef62</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-493aef62</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.1.0/24</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>243</availableIpAddressCount>
            <availabilityZone>us-east-1c</availabilityZone>
            <availabilityZoneId>use1-az2</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>Name</key>
                    <value>hcl-east-1c1</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>KubernetesCluster</key>
                    <value>netpx8oi9q</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-06a3ecf21d9f7418b</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-06a3ecf21d9f7418b</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.3.224/27</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>25</availableIpAddressCount>
            <availabilityZone>us-east-1e</availabilityZone>
            <availabilityZoneId>use1-az3</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>hcl-east-1e</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>N</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-0563c92f</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-0563c92f</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.12.192/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>56</availableIpAddressCount>
            <availabilityZone>us-east-1c</availabilityZone>
            <availabilityZoneId>use1-az2</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1c-04</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-8d4a2ffb</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-8d4a2ffb</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.15.0/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1d</availabilityZone>
            <availabilityZoneId>use1-az4</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1d-05</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-af68c285</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-af68c285</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.13.128/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1c</availabilityZone>
            <availabilityZoneId>use1-az2</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1c-07</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-0271f9bced64e45a0</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-0271f9bced64e45a0</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.3.128/27</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>26</availableIpAddressCount>
            <availabilityZone>us-east-1b</availabilityZone>
            <availabilityZoneId>use1-az1</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-shared-resource</key>
                    <value>N</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>WIPRO</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>WIPRO-AZ-1b</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-52fa460a</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-52fa460a</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.10.128/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1a</availabilityZone>
            <availabilityZoneId>use1-az6</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1a-03</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-7d942e25</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-7d942e25</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.11.128/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1a</availabilityZone>
            <availabilityZoneId>use1-az6</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1a-07</value>
                </item>
                <item>
                    <key>creator</key>
                    <value>dinsmore</value>
                </item>
                <item>
                    <key>eco-creator</key>
                    <value>dinsmore</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>eco-email</key>
                    <value>dinsmore@netapp.com</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-04250b29</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-04250b29</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-62720a04</vpcId>
            <cidrBlock>10.0.3.0/24</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>250</availableIpAddressCount>
            <availabilityZone>us-east-1c</availabilityZone>
            <availabilityZoneId>use1-az2</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-shared-resource</key>
                    <value>N</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>SGWS_Private_2</value>
                </item>
                <item>
                    <key>KubernetesCluster</key>
                    <value>netv3fdokz</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-df2a2f84</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-df2a2f84</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-62720a04</vpcId>
            <cidrBlock>10.0.4.0/24</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>250</availableIpAddressCount>
            <availabilityZone>us-east-1a</availabilityZone>
            <availabilityZoneId>use1-az6</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>KubernetesCluster</key>
                    <value>netv3fdokz</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>N</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>SGWS_Private_3</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-32553044</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-32553044</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.15.64/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1d</availabilityZone>
            <availabilityZoneId>use1-az4</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>creator</key>
                    <value>dinsmore</value>
                </item>
                <item>
                    <key>eco-email</key>
                    <value>dinsmore@netapp.com</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1d-06</value>
                </item>
                <item>
                    <key>eco-creator</key>
                    <value>dinsmore</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-9234bae5</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-9234bae5</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.5.0/24</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>249</availableIpAddressCount>
            <availabilityZone>us-east-1d</availabilityZone>
            <availabilityZoneId>use1-az4</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>hcl-east-1d2</value>
                </item>
                <item>
                    <key>KubernetesCluster</key>
                    <value>netp8ix22p</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-4668c26c</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-4668c26c</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.13.64/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1c</availabilityZone>
            <availabilityZoneId>use1-az2</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1c-06</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-f0553086</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-f0553086</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.15.128/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1d</availabilityZone>
            <availabilityZoneId>use1-az4</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1d-07</value>
                </item>
                <item>
                    <key>eco-email</key>
                    <value>dinsmore@netapp.com</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>eco-creator</key>
                    <value>dinsmore</value>
                </item>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>creator</key>
                    <value>dinsmore</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-7dfa4625</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-7dfa4625</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.10.192/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1a</availabilityZone>
            <availabilityZoneId>use1-az6</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1a-04</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <subnetId>subnet-b4972dec</subnetId>
            <subnetArn>arn:aws:ec2:us-east-1:210811600188:subnet/subnet-b4972dec</subnetArn>
            <state>available</state>
            <ownerId>210811600188</ownerId>
            <vpcId>vpc-7d4a2818</vpcId>
            <cidrBlock>172.30.11.0/26</cidrBlock>
            <ipv6CidrBlockAssociationSet/>
            <availableIpAddressCount>59</availableIpAddressCount>
            <availabilityZone>us-east-1a</availabilityZone>
            <availabilityZoneId>use1-az6</availabilityZoneId>
            <defaultForAz>false</defaultForAz>
            <mapPublicIpOnLaunch>false</mapPublicIpOnLaunch>
            <tagSet>
                <item>
                    <key>eco-shared-resource</key>
                    <value>Y</value>
                </item>
                <item>
                    <key>eco-creator</key>
                    <value>dinsmore</value>
                </item>
                <item>
                    <key>eco-groupname</key>
                    <value>HCL</value>
                </item>
                <item>
                    <key>Name</key>
                    <value>HCL-AWS-VPN01-HA-us-east-1a-05</value>
                </item>
                <item>
                    <key>eco-email</key>
                    <value>dinsmore@netapp.com</value>
                </item>
                <item>
                    <key>creator</key>
                    <value>dinsmore</value>
                </item>
            </tagSet>
            <assignIpv6AddressOnCreation>false</assignIpv6AddressOnCreation>
            <mapCustomerOwnedIpOnLaunch>false</mapCustomerOwnedIpOnLaunch>
            <privateDnsNameOptionsOnLaunch>
                <hostnameType>ip-name</hostnameType>
                <enableResourceNameDnsARecord>false</enableResourceNameDnsARecord>
                <enableResourceNameDnsAAAARecord>false</enableResourceNameDnsAAAARecord>
            </privateDnsNameOptionsOnLaunch>
            <ipv6Native>false</ipv6Native>
            <enableDns64>false</enableDns64>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
    </subnetSet>
</DescribeSubnetsResponse>`

export default ec2subnets;
